<div class="modal--generic edit-signer-name__modal">
  <h1 class="modal__header">The owner is not the insured's legal guardian, so the owner can't be the signer.</h1>
  <p class="modal__text">The signer must be the insured's parent or legal guardian.</p>

  <div class="modal__actions modal__actions--inline">
    <button cpdsButton theme="mm-light" variant="secondary" (click)="confirm()">Edit signer name</button>
    <button cpdsButton theme="mm-light" variant="tertiary" (click)="cancel()">Go Back</button>
  </div>
</div>
